import { render } from "./CineMedias.vue?vue&type=template&id=0d1553b9&ts=true"
import script from "./CineMedias.vue?vue&type=script&lang=ts"
export * from "./CineMedias.vue?vue&type=script&lang=ts"

import "./CineMedias.vue?vue&type=style&index=0&id=0d1553b9&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__